import React from "react"
import PropTypes from "prop-types"
import MobileStepper from "@mui/material/MobileStepper"
import Button from "@mui/material/Button"
import SwipeableViews from "react-swipeable-views"

// FIXME checkout https://mui.com/components/use-media-query/#migrating-from-withwidth
const withWidth = () => (WrappedComponent) => (props) => (
  <WrappedComponent {...props} width="xs" />
)

const SwipeableWithPager = ({ items }) => {
  const [activeStep, setActiveStep] = React.useState(0)

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }

  const handleStepChange = (idx) => setActiveStep(idx)

  return (
    <>
      <SwipeableViews
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
      >
        {items}
      </SwipeableViews>
      <MobileStepper
        variant="dots"
        steps={items.length}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === items.length - 1}
          >
            Next
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            Back
          </Button>
        }
      />
    </>
  )
}

SwipeableWithPager.propTypes = {
  items: PropTypes.array.isRequired,
}

export default withWidth()(SwipeableWithPager)
